import './styles/integration-details.scss'

import React      from 'react'
import PropTypes  from 'prop-types'

import DetailsSection   from '../components/DetailsSection'
import DetailsHeader    from '../components/DetailsHeader'
import Loading          from '../components/Loading'
import IntegrationSteps from './IntegrationSteps'
import IntegrationDataSources from './IntegrationDataSources'

import api from '../redux/api'
import ModalComponent from '../components/ModalComponent'

export default class IntegrationDetails extends React.Component {
  static propTypes = {
    match:   PropTypes.object.isRequired,
  }

  state = {
    data:    null,
    loading: true,
    error: false
  }

  componentDidMount() {
    const { id } = this.props.match.params

    api.loadIntegration(id).then((result) => {
      this.setState({ loading: false, data: result })
    })
    .catch((err) => {
      this.setState({error:true,loading:false})
      console.log(err)
    })
  }

  render() {
    const { loading, data, error} = this.state

    if (loading) return <Loading />
    else if(error) return <ModalComponent/>

    return (
      <div className="integration-details">
        <DetailsHeader title={data.name} description={data.description} type={'Integration'} />

        <div className="content">
          <div className="config-details">
            
            {data.sender && (
              <DetailsSection
                title="Sender"
                name={data.sender.name}
                description={data.sender.description}
                url={`/data-systems/item/${data.sender.id}`}
              />
            )}

            {data.receiver && (
              <DetailsSection
                title="Receiver"
                name={data.receiver.name}
                description={data.receiver.description}
                url={`/data-systems/item/${data.receiver.id}`}
              />
            )}

            {data.dataType && (
              <DetailsSection
                title="Data Type"
                name={data.dataType.name}
                description={data.dataType.description}
                url={`/data-types/item/${data.dataType.id}`}
              />
            )}

            {data.deliveryConfig && (
              <DetailsSection
                title="Delivery Config"
                name={data.deliveryConfig.name}
                description={`id: ${data.deliveryConfig.id}`}
                url={`/delivery-config/${data.deliveryConfig.id}`}
              />
            )}

          </div>
          <IntegrationDataSources integration={data} />

          <IntegrationSteps steps={data.steps} />
        </div>
      </div>
    )
  }
}